import React from 'react';
import styled from 'styled-components';
import TrueImpactText from '../base/TrueImpactText';
import { COLORS } from '../settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactBulletPointProps {
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any;
  color?: keyof typeof COLORS;
  className?: string;
}

const StyledDiv = styled.div`
  display: flex;
  text-align: left;
  svg {
    width: 16px;
    height: 16px;
    margin-right: ${SPACERS.tiny};
    margin-top: ${SPACERS.extraTiny};
  }
`;

const TrueImpactBulletPoint: React.FC<TrueImpactBulletPointProps> = ({
  text,
  icon,
  color = COLORS.ctaPrimary,
  className,
}) => {
  return (
    <StyledDiv className={className}>
      <FontAwesomeIcon color={color} icon={icon ? icon : faCircleCheck} />
      <TrueImpactText>{text}</TrueImpactText>
    </StyledDiv>
  );
};

export default TrueImpactBulletPoint;
